import firebase from 'firebase';
import {
  REPORT_API_KEY,
  REPORT_AUTH_DOMAIN,
  REPORT_DATABASE_URL,
  REPORT_PROJECT_ID,
  REPORT_STORAGEBUCKET,
  REPORT_MESSAGING_SENDER_ID,
  REPORT_APP_ID,
} from 'appenv';

const config = {
  apiKey: REPORT_API_KEY,
  authDomain: REPORT_AUTH_DOMAIN,
  databaseURL: REPORT_DATABASE_URL,
  projectId: REPORT_PROJECT_ID,
  storageBucket: REPORT_STORAGEBUCKET,
  messagingSenderId: REPORT_MESSAGING_SENDER_ID,
  appId: REPORT_APP_ID,
};

let production = null;
if (!firebase.apps.length) {
  production = firebase.initializeApp(config);
} else {
  production = firebase.app();
}

firebase.auth(production).signInAnonymously();

export default firebase.firestore();
